<template>
  <div class="relative bg-white shadow-md rounded-sm p-7 flex flex-col justify-center">
    <div class="text-[1.2rem] flex flex-row items-center gap-4 mb-4">
      <Icon v-if="props.variant !== 'wide'" name="Clipboard" class="inline-block align-middle" :scale="1.5" />
      <h2 class="text-lg-24 font-semibold text-start">
        {{ $t("pages.account.password-reset.sections.results.title") }}
      </h2>
    </div>
    <p :class="cn('relative z-1', props.variant === 'default' && 'md:max-w-[230px]')">
      {{ $t("pages.account.password-reset.sections.results.pre_description") }}
      <NuxtLinkLocale
        :locale="switchBlogLocale()"
        to="/account/dashboard/results"
        class="text-secondary underline hover:no-underline"
      >
        {{ $t("commons.patient_area") }}
      </NuxtLinkLocale>
      {{
        $t(
          `pages.account.password-reset.sections.results.${props.variant === "wide" ? "post_short_description" : "post_description"}`
        )
      }}
    </p>

    <NuxtImg
      src="/img/reset-password-patient-area.svg"
      alt=""
      width="173"
      height="106"
      class="-mb-7 mt-8 ml-auto md:mb-0 md:absolute bottom-0 right-4"
    />
  </div>
</template>

<script setup lang="ts">
interface LookingForTestResultCardProps {
  variant?: "default" | "wide";
}

const props = withDefaults(defineProps<LookingForTestResultCardProps>(), {
  variant: "default",
});
</script>
